import { AirHandlerTypeCodeType } from 'data/types';
import { AirHandlerPlacement } from 'utils/air-handler-mounting-types';

const AIR_HANDLER_PLACEMENTS: Record<
  AirHandlerTypeCodeType,
  AirHandlerPlacement
> = {
  wall: 'wall',
  heatingConsole: 'wall',
  console: 'wall',
  wallDIY: 'wall',
  cassette: 'free',
  cassette_16: 'free',
  cassette_drop_ceiling: 'free',
  ducted: 'free',
  evap_coil: 'free',
  concealed: 'center',
  concealed_high_static: 'center'
};

const CEILING_MOUNTED_AIR_HANDLERS: ReadonlySet<AirHandlerTypeCodeType> =
  new Set<AirHandlerTypeCodeType>([
    'cassette',
    'cassette_16',
    'cassette_drop_ceiling',
    'concealed',
    'concealed_high_static',
    'ducted'
  ]);

export function getAirHandlerPlacement(
  airHandlerTypeCode: AirHandlerTypeCodeType
): AirHandlerPlacement {
  return AIR_HANDLER_PLACEMENTS[airHandlerTypeCode];
}

export function isWallMountedAirHandler(
  airHandlerTypeCode: AirHandlerTypeCodeType
): boolean {
  return getAirHandlerPlacement(airHandlerTypeCode) === 'wall';
}

export function isCeilingMountedAirHandler(
  airHandlerTypeCode: AirHandlerTypeCodeType
): boolean {
  return CEILING_MOUNTED_AIR_HANDLERS.has(airHandlerTypeCode);
}
